import React from 'react';
import { range } from 'lodash';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { TileGrid } from '../../TileGrid/TileGrid';
import './MyCoursesWidgetSkeleton.scss';

export const MyCoursesWidgetSkeleton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <TileGrid className="myCoursesWidgetSkeleton">
      {range(6).map((_, index) => (
        <Skeleton
          key={index}
          className="courseTileSkeleton"
          aria-label={t('loading_content', { defaultValue: 'Inhalte werden geladen...' })}
        >
          <SkeletonItem shape="rectangle" className="skeletonItem" />
        </Skeleton>
      ))}
    </TileGrid>
  );
};
